import { createContext } from 'react';

export const IntakePageFooterPortalContext = createContext<HTMLElement | null>(null);
